import * as React from "react";

export const Header = () => {
  return (
    <header className="flex justify-between items-center px-20 py-14 bg-white max-md:p-10 max-sm:p-5">
      <h4 className="text-xl font-medium leading-8 text-black">
        WildHacks 2025 / BeeHacks
      </h4>
      <nav className="flex items-center">
      </nav>
    </header>
  );
};
